import { SYMPTOM_OPTIONS } from '@/components/AttendanceForm/espondiloartrites/constants/symptom'
import EspondiloartritesAsasPhase from '@/components/AttendanceForm/espondiloartrites/phase/EspondiloartritesAsasPhase.vue'
import EspondiloartritesDiseaseActivityPhase from '@/components/AttendanceForm/espondiloartrites/phase/EspondiloartritesDiseaseActivityPhase.vue'
import EspondiloartritesHypothesisPhase from '@/components/AttendanceForm/espondiloartrites/phase/EspondiloartritesHypothesisPhase.vue'
import EspondiloartritesMdaPhase from '@/components/AttendanceForm/espondiloartrites/phase/EspondiloartritesMdaPhase.vue'
import EspondiloartritesMedicineHistoryPhase from '@/components/AttendanceForm/espondiloartrites/phase/EspondiloartritesMedicineHistoryPhase.vue'
import EspondiloartritesReportPhase from '@/components/AttendanceForm/espondiloartrites/phase/EspondiloartritesReportPhase.vue'
import EspondiloartritesSinglePhase from '@/components/AttendanceForm/espondiloartrites/phase/EspondiloartritesSinglePhase.vue'
import EspondiloartritesSymptomsPhase from '@/components/AttendanceForm/espondiloartrites/phase/EspondiloartritesSymptomsPhase.vue'
import EspondiloartritesHypothesis from '@/components/AttendanceForm/espondiloartrites/summary/EspondiloartritesHypothesis.vue'
import EspondiloartritesSummary from '@/components/AttendanceForm/espondiloartrites/summary/EspondiloartritesSummary.vue'
import ExaminationsPhase from '@/components/AttendanceForm/general/phase/ExaminationsPhase'
import FamilyHistoryPhase from '@/components/AttendanceForm/general/phase/FamilyHistoryPhase.vue'
import FlaresPhase from '@/components/AttendanceForm/general/phase/FlaresPhase.vue'
import ImagePhase from '@/components/AttendanceForm/general/phase/ImagePhase.vue'
import LmePhase from '@/components/AttendanceForm/general/phase/LmePhase.vue'
import MedicinesPhase from '@/components/AttendanceForm/general/phase/MedicinesPhase.vue'
import PasiBsaPhase from '@/components/AttendanceForm/general/phase/PasiBsaPhase.vue'
import PersonalHistoryPhase from '@/components/AttendanceForm/general/phase/PersonalHistoryPhase.vue'
import PsychiatricScreeningPhase from '@/components/AttendanceForm/general/phase/PsychiatricScreeningPhase.vue'
import VaccinationPhase from '@/components/AttendanceForm/general/phase/VaccinationPhase.vue'
import { util } from '@/plugins/util'
import { AttendanceConfig } from './AttendanceConfig'
import {
  generateFamilyHistoryOverview,
  generateNotesOverview,
  generatePersonalHistoryOverview,
  generatePsychiatricScreenOverview,
} from './defaultConfig'

export const normal = new AttendanceConfig()
  .addStep('Anamnese')
  .addPhase('sintomas', 'Sintomas', EspondiloartritesSymptomsPhase, generateSymptomsOverview)
  .addPhase(
    'historico_medicamentoso',
    'Histórico medicamentoso',
    EspondiloartritesMedicineHistoryPhase,
    generateMedicineHistoryOverview,
    false,
  )
  .addPhase(
    'investigacao_pessoal',
    'Investigação pessoal',
    PersonalHistoryPhase,
    generatePersonalHistoryOverview,
    false,
  )
  .addPhase('investigacao_familiar', 'Investigação familiar', FamilyHistoryPhase, generateFamilyHistoryOverview, false)
  .addPhase(
    'triagem_psiquiatrica',
    'Triagem psiquiátrica',
    PsychiatricScreeningPhase,
    generatePsychiatricScreenOverview,
    false,
  )
  .addStep('Score')
  .addPhase('asas', 'Asas', EspondiloartritesAsasPhase, generateNotesOverview)
  .addPhase('atividades_doenca', 'Atividades da doença', EspondiloartritesDiseaseActivityPhase, generateNotesOverview)
  .addPhase('mda', 'MDA', EspondiloartritesMdaPhase, undefined, true, false)
  .addPhase('pasi_bsa', 'PASI + BSA', PasiBsaPhase, generateNotesOverview, false)
  .addPhase('exames', 'Exames', ExaminationsPhase, undefined, false)
  .addPhase('crises', 'Crises (Flares)', FlaresPhase, generateNotesOverview, false)
  .addPhase('vacinas', 'Vacinas', VaccinationPhase, generateNotesOverview, false)
  .addPhase('imagens', 'Imagens', ImagePhase, undefined, false)

  .addStep('Resultados')
  .addPhase('hipotese', 'Hipótese', EspondiloartritesHypothesisPhase, undefined, false)
  .addPhase('medicamentos', 'Medicamentos', MedicinesPhase)
  .addPhase('relatorio_medico', 'Relatório médico', EspondiloartritesReportPhase, undefined, false)
  .addPhase('lme', 'LME', LmePhase, undefined, false)

  .setSummaryComponent(EspondiloartritesSummary)
  .setHypothesisComponent(EspondiloartritesHypothesis)

export const minimal = new AttendanceConfig()
  .addStep('Atendimento')
  .addPhase('diagnostico', 'Diagnóstico', EspondiloartritesSinglePhase)

function generateSymptomsOverview(data, attendance) {
  if (!data) {
    return []
  }

  const paragraphs = []

  const checkedSymptoms = Object.keys(data.symptoms || {})
    .filter((key) => data.symptoms[key].value)
    .map((key) => ({ ...data.symptoms[key], key }))

  if (checkedSymptoms.length > 0) {
    const texts = checkedSymptoms.map((symptom) => {
      const symptomOption = SYMPTOM_OPTIONS.find((item) => item.key === symptom.key)
      const symptomName = symptomOption.name
      const period = isNaN(parseInt(symptom.period?.length))
        ? 'Sim'
        : symptom.period.length + (symptom.period.type === 'MES' ? ' mes(es)' : ' ano(s)')
      const suboptions = (symptomOption.options || [])
        .filter((suboption) => symptom.options.includes(suboption.key))
        .map((suboption) => suboption.name)
        .join(', ')

      let text = `${symptomName}: ${period}`
      if (suboptions) {
        text += ` (${suboptions})`
      }
      return `${text}.`
    })

    paragraphs.push(...texts)
  }

  paragraphs.push(...generateNotesOverview(data, attendance))

  return paragraphs
}

function generateMedicineHistoryOverview(data, attendance) {
  if (!data) {
    return []
  }

  const paragraphs = []

  if (data.profile['contraindicacao_aines']?.value) {
    paragraphs.push(`Paciente tem intolerância ou contraindicação a AINES.`)
  }

  const chosenMedicines = Object.keys(data.medicines || {})
    .map((key) => data.medicines[key])
    .sort(util.objectSorter((item) => item.medicine.category.name.toLowerCase() + item.medicine.name.toLowerCase()))

  for (const item of chosenMedicines) {
    if (paragraphs.length > 0) {
      paragraphs.push('')
    }

    const medicine = item.medicine
    const periods = item.periods || []

    paragraphs.push(`${medicine.name} (${medicine.category.name})`)
    const periodTexts = periods.map((period) => {
      let recurrence = 'por semana'
      if (period.period === 'DIAS') {
        recurrence = 'por dia'
      } else if (period.period === 'CADA_N_SEMANAS') {
        recurrence = `a cada ${period.length} `
        recurrence += period.length > 1 ? 'semanas' : 'semana'
      }
      let string =
        `- ` +
        (period.dosage ? `${period.dosage}mg ${recurrence}, ` : '') +
        `de ${util.toFormattedDate(period.start)} até ${util.toFormattedDate(period.end) || 'atualmente'}.`
      if (!period.start) {
        string = `${period.dosage}mg ${recurrence} sem período informado.`
      }
      if (period.stopReason) {
        string += ` Motivo da parada: ${period.stopReason.name ?? period.stopReason ?? 'não informado'}.`
      }

      return string
    })
    paragraphs.push(...periodTexts)
  }

  paragraphs.push(...generateNotesOverview(data, attendance))

  return paragraphs
}
